<template>
  <div class="ColumnContainer">
    <common ref="common" />
    <v-toolbar dark class="FixedItem" style="width: 100%">
      <v-list-item-title class="title"> Member Detail </v-list-item-title>
      <v-btn icon large @click="closedialog()">
        <v-icon>mdi-36px mdi-chevron-left</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card class="ScrollContainer" tile>
      <v-row align="end" class="fill-height" no-gutters>
        <v-col
          align-self="center"
          cols="24"
          class="text-left"
          v-if="member.ledger"
        >
          <v-list>
            <v-list-item>
              <v-list-item-action>
                <v-icon>mdi-account</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title
                  class="title"
                  v-if="
                    member.salutation !== null &&
                    member.salutation.indexOf('.') > -1
                  "
                  >{{ member.salutation }} {{ member.name }}</v-list-item-title
                >
                <v-list-item-title class="title" v-else>
                  <v-list-item-title
                    class="title"
                    v-if="
                      member.salutation !== null &&
                      member.salutation.indexOf('.') === -1
                    "
                    >{{ member.salutation }}
                    {{ member.name }}</v-list-item-title
                  >
                  <v-list-item-title class="title" v-else>{{
                    member.name
                  }}</v-list-item-title>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item>
              <v-list-item-action>
                <v-icon>mdi-account-group</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title v-if="member.groupName !== null">
                  {{ member.groupName }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item>
              <v-list-item-action>
                <v-icon>mdi-card-account-details</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title v-if="member.code !== null">
                  {{ member.code }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item>
              <v-list-item-action>
                <v-icon>mdi-calendar-range</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title v-if="member.joinDate !== null">
                  {{ DateFormat(member.joinDate) }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item v-if="member.ledger.person.permanentAddress !== null">
              <v-list-item-action>
                <v-icon>mdi-map-marker</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title
                  v-if="
                    member.ledger.person.permanentAddress.doorNumber !== null
                  "
                >
                  {{
                    member.ledger.person.permanentAddress.doorNumber
                  }}</v-list-item-title
                >
                <v-list-item-title
                  v-if="member.ledger.person.permanentAddress.place !== null"
                >
                  {{
                    member.ledger.person.permanentAddress.place
                  }}</v-list-item-title
                >
                <v-list-item-title
                  v-if="member.ledger.person.permanentAddress.city !== null"
                >
                  {{
                    member.ledger.person.permanentAddress.city
                  }}</v-list-item-title
                >
                <v-list-item-title
                  v-if="member.ledger.person.permanentAddress.pinCode !== null"
                >
                  {{
                    member.ledger.person.permanentAddress.pinCode
                  }}</v-list-item-title
                >
                <v-list-item-title
                  v-if="
                    member.ledger.person.permanentAddress.doorNumber === null &&
                    member.ledger.person.permanentAddress.place === null &&
                    member.ledger.person.permanentAddress.city === null &&
                    member.ledger.person.permanentAddress.pinCode === null
                  "
                  >{{ "N/A" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>
            <v-list-item>
              <v-list-item-action>
                <v-icon>mdi-phone</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <a
                  :href="`tel:${member.mobileNumber}`"
                  style="color: white; text-decoration: none"
                >
                  <v-list-item-title
                    v-if="
                      member.mobileNumber !== null &&
                      this.member.mobileNumber.trim().length > 0
                    "
                    >{{ member.mobileNumber }}</v-list-item-title
                  >
                </a>
                <v-list-item-title
                  v-if="
                    member.mobileNumber === null ||
                    this.member.mobileNumber.trim().length === 0
                  "
                  >{{ "N/A" }}</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item>
              <v-list-item-action>
                <v-icon>mdi-email</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title v-if="member.ledger.person.emailId !== null">
                  {{ member.ledger.person.emailId }}
                </v-list-item-title>
                <v-list-item-title v-if="member.ledger.person.emailId === null">
                  {{ "N/A" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item>
              <v-list-item-action>
                <v-icon>mdi-cake-variant</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title
                  v-if="member.ledger.person.dateOfBirth !== null"
                >
                  {{ DateFormat(member.ledger.person.dateOfBirth) }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item>
              <v-list-item-action>
                <v-icon>mdi-briefcase</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title v-if="member.profession !== null">
                  {{ member.profession }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item>
              <v-list-item-action>
                <v-icon>mdi-human-male-female</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title v-if="member.spouse !== null">
                  {{ member.spouse }}
                </v-list-item-title>
                <v-list-item-title v-if="member.spouse === null">
                  {{ "N/A" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item>
              <v-list-item-action>
                <v-icon>mdi-human-male-child</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title
                  v-if="member.childCount !== null && member.childCount !== 0"
                >
                  {{ member.childCount }}
                </v-list-item-title>
                <v-list-item-title
                  v-if="member.childCount === null || member.childCount === 0"
                >
                  {{ "N/A" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item>
              <v-list-item-action>
                <v-icon>mdi-water</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title v-if="member.bloodGroup !== null">
                  {{ member.bloodGroup }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item> </v-list-item>
            <v-list-item> </v-list-item>
            <v-list-item> </v-list-item>
            <v-list-item> </v-list-item>
            <v-list-item> </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import common from "@/components/tools/common";
import { callApi } from "@/api/others";
import dayjs from "dayjs";
export default {
  components: { common },
  props: {
    memberId: {
      type: String,
      default: "",
    },
    propdialog: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      member: {},
      dialog: this.propdialog,
    };
  },
  mounted() {
    this.getDetails();
  },
  methods: {
    getDetails() {
      var common = this.$refs.common;
      if (this.memberId) {
        var url = "/api/wesupport/Member/getbyidminified";
        var Data = {
          id: this.memberId,
        };
        callApi(url, "post", Data)
          .then((response) => {
            this.member = response.data.data;
            this.member.joinDate = new Date(this.member.joinDate);
            if (
              this.member.ledger.person.dateOfBirth !== null &&
              this.member.ledger.person.dateOfBirth !== "" &&
              this.member.ledger.person.dateOfBirth !== undefined
            ) {
              this.member.ledger.person.dateOfBirth = new Date(
                this.member.ledger.person.dateOfBirth
              );
            }
          })
          .catch((error) => {
            common.ManageResponse(error);
          });
      }
    },
    closedialog() {
      this.dialog = false;
      this.$emit("update:propdialog", this.dialog);
    },
    DateFormat(d) {
      return dayjs(d).format("DD-MM-YYYY");
    },
  },
};
</script>

<style>
.ScrollContainer {
  top: auto;
}
</style>
